import * as React from "react";
import { useState } from "react";
import { logger } from "../../utilities/logger";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
//import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import MuiCard from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import AppTheme from "../../theme/AppTheme";
import Logo from '../../assests/images/logo2.png';
import { LoginService } from "../../services/LoginService";
import { LocalStorageService } from "../../services/LocalStorageService";
import { InputAdornment } from '@mui/material'
import IconButton from '@mui/material/IconButton';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { CircularProgress } from "@mui/material";


const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: "auto",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "450px",
  },
  backgroundColor: "#faf9f7",
  boxShadow: "none",
  borderRadius: 8,
  // ── Any <img> inside this Card automatically keeps its aspect ratio ──
  "& img": {
    display: "block",
    maxWidth: "100%",
    width: "100%",
    height: "auto",
    objectFit: "contain",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));
const SignInContainer = styled(Stack)(({ theme }) => ({
  height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
  minHeight: "100%",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },
  backgroundColor: "rgb(255, 255, 254)",  // ← same as body background
  "&::before": {
    content: '""',
    display: "none",   // ← removes the radial gradient
  },
}));


export default function Login(props) {
  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState("");
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const [Loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    if (emailError || passwordError) {
      event.preventDefault();
      return;
    }
  };

  React.useEffect(() => {
    // Clear any stale session on returning to login page
    localStorage.clear();
  }, []);

  const validateInputs = async (e) => {
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;

    let isValid = true;

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setEmailError(true);
      setEmailErrorMessage("Please enter a valid email address.");
      isValid = false;
    } else {
      setEmailError(false);
      setEmailErrorMessage("");
    }

    if (!password || password.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage("Password must be at least 6 characters long.");
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage("");
    }
    if (!isValid) {
      return false;
    }
    e.preventDefault();

    const result = await LoginService.SignIn(email, password);
    logger.debug("SignIn result:", result);
    //if username or password field is empty, return error message
    if (result !== false) {
      //Signin Success
      LocalStorageService.setUserId(result.userid);
      LocalStorageService.setEmail(result.email);
      LocalStorageService.setIsAuthenticated(true);
      LocalStorageService.setDesignerName(result.designerName);
      LocalStorageService.setRole(result.role);
      window.location.pathname = "/";
    } else {
      //If credentials entered is invalid
      setErrorMessage((prevState) => ({ value: "Invalid email/password" }));
      isValid = false;
    }
    return isValid;
  };

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <SignInContainer direction="column" justifyContent="space-between">
        <Card variant="outlined">
          <img src={Logo} alt="Design Logo" />
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: 2,
            }}
          >
            <FormControl>
              <FormLabel htmlFor="email">Email</FormLabel>
              <TextField
                error={emailError}
                helperText={emailErrorMessage}
                id="email"
                type="email"
                name="email"
                placeholder="username@cbdbarrie.com"
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={emailError ? "error" : "primary"}
              />
            </FormControl>
            <FormControl>
              <FormLabel htmlFor="password">Password</FormLabel>
              <TextField
                error={passwordError}
                helperText={passwordErrorMessage}
                name="password"
                placeholder="••••••"
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={passwordError ? "error" : "primary"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={togglePasswordVisibility}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? (
                          <VisibilityOutlinedIcon />
                        ) : (
                          <VisibilityOffOutlinedIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <Button
              type="submit"
              variant="contained"
              style={{ backgroundColor: "#352c1d", fontWeight: "bold" }}
              //onClick={validateInputs}
              onClick={async (e) => {
                e.preventDefault(); // prevent default form submission
                setLoading(true);
                try {
                  const isValid = await validateInputs(e); // pass event
                  if (isValid) { /* post-login logic placeholder */ }
                } catch (err) {
                  logger.error("Login error:", err);
                } finally {
                  setLoading(false); // stop spinner in all cases
                }
              }}
            >
              {Loading ? (
                <CircularProgress size={24} color="inherit" sx={{ width: '200' }} />
              ) : (
                "Sign in"
              )}
            </Button>
            {/*
<Link
  to="/forgot-password"
  style={{
    color: "#bda485",
    textDecoration: "none",
    textAlign: "end",
    fontWeight: "bold",
    display: "block"
  }}
>
  Forgot Password?
</Link>
            */}

            {errorMessage.value && (
              <p style={{ color: "hsl(0, 90%, 40%)" }}>
                {" "}
                {errorMessage.value}{" "}
              </p>
            )}
          </Box>
        </Card>
      </SignInContainer>
    </AppTheme>
  );
}
